import script from "./DriveTypesView.vue?vue&type=script&setup=true&lang=js"
export * from "./DriveTypesView.vue?vue&type=script&setup=true&lang=js"

import "./DriveTypesView.vue?vue&type=style&index=0&id=175d9139&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-175d9139"]])

export default __exports__